<!--智能超分活动  注意此页面需要拼接share=0参数，适配卷帘顶部高度，避免进入标题下方-->
<template>
  <div id="superResolutionImageActivity">
    <!--卷帘展示-->
    <div class="compareMapArea" :style="style">
      <l-map v-if="initLeaflet" ref="compareMap" :center="initCenter" :zoom="initZoom" :options="option" :maxBounds="maxBounds"></l-map>
    </div>
    <!--地图展示-->
    <div :style="{'z-index':showType === 'map' ? 1 : 0}" class="mapArea">
      <l-map v-if="initLeaflet" ref="map" :center="initCenter" :zoom="initZoom" :options="option" :maxBounds="maxBounds">
        <l-tile-layer :url="this.compareType_bottomLayer" :options="{tms:true}"/>
        <l-tile-layer :opacity="mapType_showSuperImage ? 1 : 0" :url="this.compareType_topLayer" :options="{tms:true}"/>
      </l-map>
    </div>

    <!--超分前后标签-->
    <div style="position:absolute;bottom:34px;right:12px;width:60px;height:30px;background:rgba(0, 0, 0, 0.6);border-radius:8px;text-align:center;z-index:999;">
      <p style="line-height:30px;font-size:14px;color:rgba(255, 255, 255, 1);">{{showType === 'compare' ? '超分前' : mapType_showSuperImage ? '超分后' : '超分前'}}</p>
    </div>
    <div v-if="showType === 'compare'" :style="{'top':topBarHeight - 20 +'px'}" style="position:absolute;bottom:32px;right:12px;width:60px;height:30px;background:rgba(0, 0, 0, 0.6);border-radius:8px;text-align:center;z-index:999;">
      <p style="line-height:30px;font-size:14px;color:rgba(255, 255, 255, 1);">超分后</p>
    </div>



    <!--工具栏-->
    <div style="position:absolute;right:12px;bottom:120px;width:38px;background:rgba(0, 0, 0, 0.6);border-radius:8px;padding:16px 0;text-align:center;z-index:999;">
      <p @click="showType = 'compare';" :style="{'color':showType === 'compare' ? 'rgba(42, 130, 228, 1)' : '#ffffff'}" style="font-size:20px;" class="iconfontFamily">&#xe7ed;</p>
      <div style="width:16px;height:2px;background:rgba(128, 128, 128, 1);margin:13px auto 0 auto;"></div>
      <p @click="showType = 'map';" @touchstart="mousedownSuperTypeBtn" @touchend="mouseupSuperTypeBtn" :style="{'color':(showType === 'map' && mapType_showSuperImage) ? 'rgba(42, 130, 228, 1)' : '#ffffff'}" style="margin-top:13px;font-size:20px;" class="iconfontFamily">&#xe7f9;</p>
    </div>

    <!--选择城市-->
    <div v-if="cityList.length !== 0" @click="chooseCityAreaShow = true;" style="position:absolute;left:10px;bottom:25px;width:120px;height:48px;border-radius:40px;background:rgba(0, 0, 0, 0.5);padding:0 12px 0 5px;display:flex;align-items:center;justify-content: space-between;z-index:999;">
      <img :src="cityList[currCityIndex].areaThumb" style="width:32px;height:32px;border:2px solid #ffffff;border-radius:50%;">
      <p style="margin-left:5px;color:#ffffff;font-size:14px;">{{cityList[currCityIndex].areaName}}</p>
      <p style="color:#ffffff;font-size:13px;" class="iconfontFamily">&#xe697;</p>
    </div>
    <div v-if="chooseCityAreaShow" style="position:absolute;top:0;left:0;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.4);z-index:999;">
      <div style="position:absolute;bottom:0;left:0;width:100%;height:240px;border-radius:16px 16px 0 0;overflow:hidden;">
        <div style="width:calc(100% - 36px);height:100%;background:rgba(0, 0, 0, 0.6);backdrop-filter: blur(20px);padding:13px 18px;">
          <div style="display:flex;align-items:center;justify-content:space-between;">
            <p style="color:#ffffff;font-size:16px;">热门城市</p>
            <p @click="chooseCityAreaShow = false;" style="color:#ffffff;font-size:12px;" class="iconfontFamily">&#xe72c;</p>
          </div>
          <div style="width:100%;margin-top:24px;white-space:nowrap;" class="myXScrollAreaWidthoutThumb">
            <div @click="chooseCity(index)" v-for="(item,index) in cityList" :key="index" style="position:relative;width:52px;height:61px;margin:0 12px;display:inline-block;">
              <img :src="item.areaThumb"
                   :style="{'border':currCityIndex === index ? '3px solid rgba(42, 130, 228, 1)' : '3px solid #ffffff'}"
                   style="width:46px;height:46px;border:3px solid #ffffff;border-radius:50%;">
              <div :style="{'background':currCityIndex === index ? 'rgba(42, 130, 228, 1)' : '#ffffff'}"
                   style="position:absolute;bottom:0;left:0;width:100%;height:17px;background:#ffffff;border-radius:8px;">
                <p :style="{'color':currCityIndex === index ? '#ffffff' : '#000000'}" style="line-height:17px;text-align:center;font-size:12px;color:#000000;">{{item.areaName}}</p>
              </div>
            </div>
          </div>
          <div style="width:100%;hieght:20px;margin-top:50px;text-align:center;">
            <p @click="chooseCityAreaShow = false;contactCustomerDialogShow = true;" style="font-size:16px;color:rgba(42, 130, 228, 1);">
              <span class="iconfontFamily">&#xe812;</span>
              定制化咨询
            </p>
          </div>
        </div>
      </div>

    </div>

    <!--联系客服-->
    <div v-if="contactCustomerDialogShow" style="position:absolute;top:0;left:0;width:100vw;height:100vh;z-index:999;">
      <div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:300px;height:250px;overflow:hidden;">
        <div style="position:relative;width:calc(100% - 2px);height:calc(100% - 2px);border-radius:10px;background:rgba(3, 5, 15, 0.6);border:1px solid rgba(255, 255, 255, 0.4);backdrop-filter: blur(20px);display:flex;flex-direction:column;align-items: center;justify-content: center;">
          <p @click="contactCustomerDialogShow = false;" style="position:absolute;top:13px;right:14px;color:rgba(196, 196, 196, 1);font-size:12px;" class="iconfontFamily">&#xe72c;</p>
          <img src="../../../assets/ContactCustomer/qrCode.jpg" style="width:104px;height:104px;">
          <p style="margin-top:3px;font-size:12px;color:#ffffff;">共生地球小助手</p>
          <p style="margin-top:16px;font-size:14px;color:#ffffff;">如有超清影像定制需求</p>
          <p style="margin-top:2px;font-size:14px;color:#ffffff;">请添加小助手微信咨询详情</p>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import L from "leaflet";
import {LMap,LTileLayer} from 'vue2-leaflet';
import '@/lib/side-by-side/leaflet-side-by-side'
export default {
  name: "SuperResolutionImage",
  components: {
    LMap,LTileLayer
  },
  data(){
    return{
      topBarHeight:86,

      initZoom: 18,
      initCenter: L.latLng(43.98, 125.4),
      maxBounds: L.latLngBounds([[85,-180], [-85,180]]),
      option: {zoomControl: false, attributionControl: false, renderer: L.canvas(), maxZoom: 18, minZoom: 15},
      initLeaflet:false,   //等获取到第一个地点后再初始化，避免立刻跳转


      currPositionCenter:[],   //当前选中城市的中心点

      //卷帘地图
      compareMap:"",

      //地图展示方式，map或compare
      showType:"map",

      //地图形式，展示高清影像
      mapType_showSuperImage:false,

      //地图形式 卷帘 两个图层
      compareType_topLayer:"",
      compareType_bottomLayer:"",


      //选择城市
      currCityIndex:0,
      cityList:[],
      chooseCityAreaShow:false,

      //联系客服
      contactCustomerDialogShow:false,


      //token
      token:"",

    }
  },
  methods:{
    //创建卷帘
    createSideBySide(){
      let topLayer = L.tileLayer(
          this.compareType_topLayer,
          {tms:true}
      ).addTo(this.$refs.compareMap.mapObject);
      let bottomLayer = L.tileLayer(
          this.compareType_bottomLayer,
          {tms:true}
      ).addTo(this.$refs.compareMap.mapObject)
      //创建卷帘
      this.compareMap = L.control.sideBySide(topLayer, bottomLayer).addTo(this.$refs.compareMap.mapObject);
      //调整input位置
      if(document.documentElement.clientHeight >= document.documentElement.clientWidth){
        document.getElementsByClassName("leaflet-sbs-range")[0].style.transform = "rotate(90deg) translateY(50vh)"
      } else {
        document.getElementsByClassName("leaflet-sbs-range")[0].style.transform = "rotate(90deg) translateY(50vw)"
      }
    },
    //设置卷帘图层
    setCompareLayers(){
      let topLayer = L.tileLayer(
          this.compareType_topLayer,
          {tms:true}
      ).addTo(this.$refs.compareMap.mapObject);
      this.compareMap.setTopLayers(topLayer)

      let bottomLayer = L.tileLayer(
          this.compareType_bottomLayer,
          {tms:true}
      ).addTo(this.$refs.compareMap.mapObject);
      this.compareMap.setBottomLayers(bottomLayer)
    },


    //超清按钮 交互
    clickSuperTypeBtn(){
      if(this.showType === "compare"){
        this.showType = "map"
      }
    },
    mousedownSuperTypeBtn(){
      console.log("按下")
      if(this.showType === "map"){
        this.mapType_showSuperImage = true
      }
    },
    mouseupSuperTypeBtn(){
      console.log("松开")
      if(this.showType === "map"){
        this.mapType_showSuperImage = false
      }
    },


    //选择城市
    chooseCity(index){
      this.compareMap.remove();
      this.initLeaflet = false;

      this.currCityIndex = index;
      this.chooseCityAreaShow = false;

      this.$http.get("/earthApi/image-super-resolution/getAreaInfo?areaId="+this.cityList[this.currCityIndex].areaId, {headers:{'Authorization': 'Bearer ' + this.token}}).then(responseDetail => {
        if(responseDetail.body.status === 200){
          console.log(responseDetail.body.data)

          this.compareType_topLayer = responseDetail.body.data.imageUrlAfter;
          this.compareType_bottomLayer = responseDetail.body.data.imageUrl;
          //中心点
          this.currPositionCenter = JSON.parse(responseDetail.body.data.areaCenter).coordinates
          this.initCenter = L.latLng(this.currPositionCenter[1],this.currPositionCenter[0]);
          //限制最大范围
          this.maxBounds =  L.geoJSON(JSON.parse(responseDetail.body.data.areaRange)).getBounds()
          //初始化地图
          this.initLeaflet = true;
          setTimeout(()=>{
            //初始化卷帘
            this.createSideBySide()
            setTimeout(()=>{
              //飞到第一个地点的位置
              this.currPositionCenter = JSON.parse(responseDetail.body.data.areaCenter).coordinates
              this.$refs.map.mapObject.setView(L.latLng(this.currPositionCenter[1],this.currPositionCenter[0]), 18)
              this.$refs.compareMap.mapObject.setView(L.latLng(this.currPositionCenter[1],this.currPositionCenter[0]), 18)
            },200)
          },0)




          //直接更新图层，不重写加载地图（卷帘在有的机型 如小米 上会异常闪动）
          // this.compareType_topLayer = responseDetail.body.data.imageUrlAfter;
          // this.compareType_bottomLayer = responseDetail.body.data.imageUrl;
          // //设置卷帘图层为第一个地点的图层
          // this.setCompareLayers()
          // //清除最大范围限制，自由flyTo
          // this.maxBounds = L.latLngBounds([[85,-180], [-85,180]])
          // setTimeout(()=>{
          //   //飞到位置
          //   this.currPositionCenter = JSON.parse(responseDetail.body.data.areaCenter).coordinates
          //   this.$refs.map.mapObject.setView(L.latLng(this.currPositionCenter[1],this.currPositionCenter[0]), 18)
          //   this.$refs.compareMap.mapObject.setView(L.latLng(this.currPositionCenter[1],this.currPositionCenter[0]), 18)
          //   setTimeout(()=>{
          //     //限制最大范围
          //     this.maxBounds =  L.geoJSON(JSON.parse(responseDetail.body.data.areaRange)).getBounds()
          //   },0)
          // },0)
        }
      })


    },



    //获取城市列表
    getCityList(){
      this.$http.get("/earthApi/image-super-resolution/getAreaList", {headers:{'Authorization': 'Bearer ' + this.token}}).then(response => {
        if(response.body.status === 200){
          console.log(response.body.data)
          this.cityList = response.body.data;
          //获取第一个地点的详情
          this.$http.get("/earthApi/image-super-resolution/getAreaInfo?cityName="+this.cityList[0].areaName, {headers:{'Authorization': 'Bearer ' + this.token}}).then(responseDetail => {
            if(responseDetail.body.status === 200){
              console.log(responseDetail.body.data)
              this.compareType_topLayer = responseDetail.body.data.imageUrlAfter;
              this.compareType_bottomLayer = responseDetail.body.data.imageUrl;
              //第一个地点的中心点
              this.currPositionCenter = JSON.parse(responseDetail.body.data.areaCenter).coordinates
              this.initCenter = L.latLng(this.currPositionCenter[1],this.currPositionCenter[0]);
              //限制最大范围
              this.maxBounds =  L.geoJSON(JSON.parse(responseDetail.body.data.areaRange)).getBounds()
              //初始化地图
              this.initLeaflet = true;
              setTimeout(()=>{
                //初始化卷帘
                this.createSideBySide()
              },0)
              setTimeout(()=>{
                //飞到第一个地点的位置
                this.currPositionCenter = JSON.parse(responseDetail.body.data.areaCenter).coordinates
                this.$refs.map.mapObject.setView(L.latLng(this.currPositionCenter[1],this.currPositionCenter[0]), 18)
                this.$refs.compareMap.mapObject.setView(L.latLng(this.currPositionCenter[1],this.currPositionCenter[0]), 18)
              },200)

            }
          })
        }
      })
    },

    //获取app端手机型号的顶栏高度，加一个合适的值，设为页面的paddingTop
    getTopBarHeight(value){
      this.topBarHeight = value;
    }

  },
  computed:{
    style() {
      //整体移至中心
      if(document.documentElement.clientHeight >= document.documentElement.clientWidth){
        return "width: 100vh; height: 100vh;margin-left:-" + parseInt((document.documentElement.clientHeight - document.documentElement.clientWidth)/2) + "px"
      } else {
        return "width: 100vw; height: 100vw;margin-top:-" + parseInt((document.documentElement.clientWidth - document.documentElement.clientHeight)/2) + "px"
      }
    },
  },

  mounted(){
    window.activityH5Page = this;
    // this.createSideBySide()

    if(window["flutter_backActivityInfo"]){
      window["flutter_backActivityInfo"].postMessage(JSON.stringify({title:"超清影像"}));
    }
    if(this.$route.query.appToken){
      this.token = this.$route.query.appToken
    }
    console.log(this.token)
    this.getCityList();
  }


}
</script>

<style scoped>

#superResolutionImageActivity{
  position:fixed;
  top:0;
  left:0;
  width:100vw;
  height:100vh;
  background:rgba(2, 15, 31, 1);
}
#superResolutionImageActivity p{
  margin:0;
}


.compareMapArea{
  position:fixed;
  top:0;
  left:0;
  width:100vw;
  height:100vh;
  z-index:1;
}
.mapArea{
  position:fixed;
  top:0;
  left:0;
  width:100vw;
  height:100vh;
}


/*横行滚动条样式*/
.myXScrollAreaWidthoutThumb{
  overflow-x:auto;
}
.myXScrollAreaWidthoutThumb::-webkit-scrollbar-track-piece{
  -webkit-border-radius:0;
}
.myXScrollAreaWidthoutThumb::-webkit-scrollbar{
  height:0;
}
.myXScrollAreaWidthoutThumb::-webkit-scrollbar-thumb{
  background-color: rgba(120, 120, 120, 1);
  -webkit-border-radius:1px;
  border: 1px solid rgba(120, 120, 120, 1);
}



* {
  /*touch-action: none;   !*禁止微信浏览器下拉*!*/
  -webkit-touch-callout: none;   /*禁止iOS Safari中的长按菜单*/
  user-select: none;   /*禁止选中文本*/
  -webkit-user-select: none; /* Chrome, Safari, Opera */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE 10+ */
}


</style>